import { AppMessageService } from "./../../../shared/core/message/app-message.service";
import { RevisaoSeloFiltroSgsia } from "./../../../shared/model/sgsia/revisao-selo-filtro-sgsia";
import { Observable } from "rxjs";
import { SuspensaoInstituicaoFiltroSgsia } from "./../../../shared/model/sgsia/suspensao-instituicao-filtro-sgsia";
import { SuspensaoInstituicaoService } from "./../../../shared/client/sgsia/suspensao-instituicao/suspensao-instituicao.service";
import { RevisaoSeloService } from "./../../../shared/client/sgsia/revisao-selo/revisao-selo.service";
import { SegurancaService } from "./../../../shared/service/seguranca.service";
import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig } from "primeng/api";
import { RevisaoSeloSgsia } from "src/app/shared/model/sgsia/revisao-selo-sgsia";
import { RespostaPaginada } from "./../../../shared/model/sgsia/paginacao-sgsia";
import { SuspensaoInstituicaoSgsia } from "./../../../shared/model/sgsia/suspensao-instituicao-sgsia";

@Component({
    selector: "app-avisos-container",
    templateUrl: "./avisos-container.component.html",
    styleUrls: ["./avisos-container.component.scss"],
})
export class AvisosContainerComponent implements OnInit {
    paginacaoSuspensoes: RespostaPaginada<SuspensaoInstituicaoSgsia>;
    paginacaoRevisoes: RespostaPaginada<RevisaoSeloSgsia>;

    constructor(
        public config: DynamicDialogConfig,
        private appMessageService: AppMessageService,
        private segurancaService: SegurancaService,
        private revisaoSeloService: RevisaoSeloService,
        private suspensaoInstituicaoService: SuspensaoInstituicaoService
    ) {}

    ngOnInit() {
        if (this.config && this.config.data) {
            this.paginacaoSuspensoes = this.config.data.suspensoes;
            this.paginacaoRevisoes = this.config.data.revisoes;
        }
    }

    loadLazyRevisoes(event: any) {
        if (
            event.first + event.rows >=
            this.paginacaoRevisoes.totalItensPaginaAtual
        ) {
            const page = event.first / event.rows;
            const pageSize = this.paginacaoRevisoes.tamanhoPagina;
            this.consultarRevisoes(page, pageSize).subscribe(
                (data) => {
                    this.paginacaoRevisoes = data;
                },
                (result) => {
                    this.appMessageService.addMensagensResposta(result);
                }
            );
        }
    }

    loadLazySuspensoes(event: any) {
        if (
            event.first + event.rows >=
            this.paginacaoSuspensoes.totalItensPaginaAtual
        ) {
            const page = event.first / event.rows;
            const pageSize = this.paginacaoSuspensoes.tamanhoPagina;
            this.consultarSuspensoes(page, pageSize).subscribe(
                (data) => {
                    this.paginacaoSuspensoes = data;
                },
                (result) => {
                    this.appMessageService.addMensagensResposta(result);
                }
            );
        }
    }

    private consultarRevisoes(
        page: number = undefined,
        pageSize: number = undefined
    ): Observable<RespostaPaginada<RevisaoSeloSgsia>> {
        const filtroRevisao = new RevisaoSeloFiltroSgsia();
        filtroRevisao.order='desc';
        filtroRevisao.orderBy='dataSolicitacao';
        if (this.segurancaService.isAnalistaFiscal()) {
            filtroRevisao.situacoes = [
                RevisaoSeloSgsia.SITUACAO_REVISAO_EM_REVISAO,
                RevisaoSeloSgsia.SITUACAO_REVISAO_SUSPENSO,
            ];
        }
        if (this.segurancaService.isGestor()) {
            filtroRevisao.situacoes = [
                RevisaoSeloSgsia.SITUACAO_REVISAO_REVISADA,
            ];
        }

        filtroRevisao.page = page;
        filtroRevisao.pageSize = pageSize;

        return this.revisaoSeloService.consultar(filtroRevisao);
    }

    private consultarSuspensoes(
        page: number = undefined,
        pageSize: number = undefined
    ): Observable<RespostaPaginada<SuspensaoInstituicaoSgsia>> {
        const filtroSuspensao = new SuspensaoInstituicaoFiltroSgsia();
        filtroSuspensao.order='desc';
        filtroSuspensao.orderBy='dataSuspensao';
        filtroSuspensao.suspenso = "SIM";
        filtroSuspensao.page = page;
        filtroSuspensao.pageSize = pageSize;

        return this.suspensaoInstituicaoService.consultar(filtroSuspensao);
    }
}
